
export const FeatureFlagActionType = {
  INITIALIZE_FLAGS: "INITIALIZE_FLAGS",
  SET_FLAGS: "SET_FLAGS",
  SET_TRAITS: "SET_TRAITS"
}
